import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import { IAuroraState } from '@apps/aurora.state';
import * as fromRootStore from '@apps/root/store';
import { Tag } from '@apps/cmdb/models';
import { GuardModalService } from '@ui/misc/guard-modal';
import { PopinComponentBase } from '@ui/misc/popin-modal/popin-component-base';
import { SelectedColor } from '@ui/components/form/controls/color-palette/selected-color';

// TODO: Add Angular decorator.
@Component({
    selector: '',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class UpsertTagComponent extends PopinComponentBase implements OnDestroy
{
    public isShown = false;
    public formGroup: UntypedFormGroup;
    protected destroyator = new Subject();
    public readonly FgColorField: string = 'fgColor';
    public readonly BgColorField: string = 'bgColor';
    public readonly CategoryField: string = 'category';
    public readonly LabelField: string = 'label';
    public readonly DescriptionField: string = 'description';
    protected colorValidator = Validators.pattern(new RegExp(/^#([a-f0-9]{6}|[a-f0-9]{3})$/i));


    get fontColor ()
    {
        return this.formGroup.get(this.FgColorField).value;
    }
    get backgroundColor ()
    {
        return this.formGroup.get(this.BgColorField).value;
    }

    get fullTagName ()
    {
        return Tag.getFullTagName(
            this.formGroup.get(this.CategoryField).value,
            this.formGroup.get(this.LabelField).value
        );
    }

    constructor (
        guardModalService: GuardModalService,
        protected store: Store<IAuroraState>
    )
    {
        super(guardModalService);
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    public changeFontColor (selectedColor: SelectedColor)
    {
        this.formGroup.get(this.FgColorField).setValue(selectedColor.color, { emitEvent: selectedColor.emit });
    }

    public changeBackgroundColor (selectedColor: SelectedColor)
    {
        this.formGroup.get(this.BgColorField).setValue(selectedColor.color, { emitEvent: selectedColor.emit });
    }

    onClosePopin = (): void =>
    {
        this.store
            .pipe(
                select(fromRootStore.getPopinFormDirtyStatus),
                take(1),
                tap((status: boolean) =>
                {
                    this.preventClosePopinForm(null, status)
                        .pipe(
                            take(1),
                            tap((dialogResult: boolean) =>
                            {
                                if (dialogResult)
                                {
                                    this.close();
                                }
                            })
                        )
                        .subscribe();
                })
            )
            .subscribe();
    };

    onClose = (): void =>
    {
        this.close();
    };

    protected abstract close (): void;
}
